module.exports = __webpack_public_path__ + "img/totalRevenue.163851b8.svg";